import React from 'react';

import {dispatch, connect} from 'utils/state_manager';


import {Translate} from 'views/module';
import {Stack, Typography} from 'views/components';


const MagicLinkRedirect = (props) => {
  const getOS = () => {
    const uaData = navigator.userAgentData?.platform;
    if (uaData) return uaData;

    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';

    if (/android/i.test(ua)) return 'Android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Win/.test(platform)) return 'Windows';
    if (/Mac/.test(platform)) return 'macOS';
    if (/Linux/.test(platform)) return 'Linux';
    return 'Unknown';
  };

  React.useEffect(() => {
    const os = getOS();

    if (os === 'Android') {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.carequilt.carebase';
    } else if (os === 'iOS') {
      window.location.href = 'https://apps.apple.com/us/app/carebase/id6739510941';
    }
  }, []);

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '95vh',
        background: 'linear-gradient(180deg,rgba(252, 246, 239, 1) 0%, rgba(255, 255, 255, 1) 100%)',
      }}
    >
      <Typography variant='h3' fontWeight={200} fontSize={42}>
        <Translate expression='redirect.Intro' />
      </Typography>
      <Typography variant='h3' fontWeight={400} fontSize={48} align='center'>
        <Translate expression='redirect.Title1' />
        {' '}
        <Typography color='primary.main' component='span' variant='h3' fontWeight={400} fontSize={48} marginBlockEnd={2} >
          <Translate expression='redirect.AppName' />
        </Typography>
        {' '}
        <Translate expression='redirect.Title2' />
      </Typography>
      <Typography variant='subtitle1' color='text.secondary' marginBlockEnd={4}>
        <Translate expression='redirect.Subtitle' />
      </Typography>
    </Stack>
  );
};

MagicLinkRedirect.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(MagicLinkRedirect));


